/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown>, e1rmText: NonNullable<unknown> }} Wrapped_Period_Strength_GainInputs */

const en_us2_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Estimated max strength of ${i?.e1rmText}, your biggest jump of the month.`);
	return /** @type {LocalizedString} */ (`Estimated max strength of ${i?.e1rmText}, your biggest jump of the year.`)
	
};

const pt_br2_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText}, seu maior salto do mês.`);
	return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText}, seu maior salto do ano.`)
	
};

const es_419_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Fuerza máxima estimada de ${i?.e1rmText}, tu mayor salto del mes.`);
	return /** @type {LocalizedString} */ (`Fuerza máxima estimada de ${i?.e1rmText}, tu mayor salto del año.`)
	
};

const pt_pt2_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText}, o teu maior salto do mês.`);
	return /** @type {LocalizedString} */ (`Força máxima estimada de ${i?.e1rmText}, o teu maior salto do ano.`)
	
};

const fr_fr2_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Force max estimée de ${i?.e1rmText}, ton plus gros bond du mois.`);
	return /** @type {LocalizedString} */ (`Force max estimée de ${i?.e1rmText}, ton plus gros bond de l'année.`)
	
};

const de_de2_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Geschätzte Maximalkraft von ${i?.e1rmText}, dein größter Sprung des Monats.`);
	return /** @type {LocalizedString} */ (`Geschätzte Maximalkraft von ${i?.e1rmText}, dein größter Sprung des Jahres.`)
	
};

const it_it2_wrapped_period_strength_gain = /** @type {(inputs: Wrapped_Period_Strength_GainInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Forza massima stimata di ${i?.e1rmText}, il tuo salto più grande del mese.`);
	return /** @type {LocalizedString} */ (`Forza massima stimata di ${i?.e1rmText}, il tuo salto più grande dell'anno.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "Estimated max strength of {e1rmText}, your biggest jump of the month." |
* | * | "Estimated max strength of {e1rmText}, your biggest jump of the year." |
*
* @param {Wrapped_Period_Strength_GainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_strength_gain = /** @type {((inputs: Wrapped_Period_Strength_GainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Strength_GainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_strength_gain(inputs)
	if (locale === "es-419") return es_419_wrapped_period_strength_gain(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_strength_gain(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_strength_gain(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_strength_gain(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_strength_gain(inputs)
	return en_us2_wrapped_period_strength_gain(inputs)
});
export { wrapped_period_strength_gain as "wrapped-period.strength_gain" }